import { useState, useEffect } from "react";
import { useReportDateRange } from "./useReportDateRange";

export const useCSCDateFilter = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  
  const { startDate: globalStartDate, endDate: globalEndDate } = useReportDateRange();

  useEffect(() => {
    if (globalStartDate && globalEndDate) {
      setStartDate(globalStartDate);
      setEndDate(globalEndDate);
    }
  }, [globalStartDate, globalEndDate]);

  const updateDateRange = (newStartDate, newEndDate) => {
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  };

  const getCurrentDateRange = () => {
    return {
      startDate: startDate || globalStartDate,
      endDate: endDate || globalEndDate
    };
  };

  return {
    startDate,
    endDate,
    updateDateRange,
    getCurrentDateRange
  };
}; 